<template>
    <div style="margin: 10px">
<!--        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >-->
<!--&lt;!&ndash;            <el-form-item label="批次号">&ndash;&gt;-->
<!--&lt;!&ndash;                <el-input v-model="formInline.batchNo" placeholder="批次号" style="width:220px"></el-input>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-form-item>&ndash;&gt;-->
<!--            <el-form-item label="开始日期">-->
<!--                <el-date-picker-->
<!--                    v-model="formInline.startDate"-->
<!--                    type="date"-->
<!--                    value-format="yyyy-MM-dd"-->
<!--                    placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="结束日期">-->
<!--                <el-date-picker-->
<!--                    v-model="formInline.endDate"-->
<!--                    type="date"-->
<!--                    value-format="yyyy-MM-dd"-->
<!--                    placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--            </el-form-item>-->


<!--            <el-form-item>-->
<!--                <el-button type="success" @click="findGiftCardBatch">查询</el-button>-->
<!--            </el-form-item>-->
<!--        </el-form>-->
        <el-table :data="balanceCardBatchList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="batchName" label="卡批次">
                <template slot-scope="scope">
                    {{batchName}}
                </template>
            </el-table-column>
            <el-table-column prop="cardId" label="卡Id"></el-table-column>
            <el-table-column prop="cardTypeName" label="卡类型" width="110"></el-table-column>
            <el-table-column prop="amount" label="卡金额"></el-table-column>
            <el-table-column prop="saleAmount" label="销售金额"></el-table-column>
            <el-table-column prop="cardStateName" label="卡状态"></el-table-column>
        </el-table>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findBalanceCardBatches} from '@/api/api';
    export default {
        data() {
            return {
                balanceCardBatchList: [],// 批次信息
                loading: true,
                formInline: {
                    platformId: 1,
                    // currentPage: 1,
                    // pageSize: 10,
                    // recordsTotal: 0
                },
                batchName:''
            }
        },
        props: ['batchNo'],
        //挂载时候执行
        mounted(){
            //初始化首页数据
            // this.queryBalanceCardBatch();
        },
        methods: {
            queryBalanceCardBatch(){
                this.loading = true;
                let param = this.formInline;
                param.recordId = this.batchNo;
                findBalanceCardBatches(param).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.balanceCardBatchList = res.data.value.detailVoList
                        this.batchName = res.data.value.batchName
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    console.log(err)
                    this.$message({
                        showClose: true,
                        message: err.message||err.data.message||'网络异常',
                        type: 'error'
                    });
                });;
            },
            //查询
            findBalanceCardBatch(){
                this.queryBalanceCardBatch();
                this.formInline.currentPage = 1
            },

            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryBalanceCardBatch();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryBalanceCardBatch();
            },
        }
    }
</script>
<style scoped>
    .customer-id{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/components/card/CardOutList.vue